import { render } from "./AppUsuarios.vue?vue&type=template&id=388618d8"
import script from "./AppUsuarios.vue?vue&type=script&lang=js"
export * from "./AppUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__